export const headerContent = `
<style>
    @font-face {
        font-weight: 400;
        font-family: YouNik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/YouNik-Regular.woff") format("woff");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: YouNik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/YouNik-Medium.woff") format("woff");
        font-display: swap;
    }
</style>

<style>
    .nd-header .link {
        cursor: pointer;
        font-weight: inherit;
        text-decoration-line: none;
        background: transparent;
        border: none;
    }
    .nd-header .link:hover {
        text-decoration-line: underline;
    }
    .nd-header .link:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }
    .nd-header .link._primary {
        color: #0f140a;
        text-decoration-color: #0f140a;
    }
    .nd-header .link._secondary {
        color: var(--primary-text-color, #000000cc);
        text-decoration-color: var(--primary-text-color, #000000cc);
    }
    .nd-header .link._legal-info {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        font-weight: 500;
        color: #0000008f;
        text-decoration-color: #0000008f;
    }
    .nd-header .link._underline-on-hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-on-hover:hover {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-on-mouse-leave {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-on-mouse-leave:hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-none {
        text-decoration-line: none;
    }
    .nd-header .link._underline-none:hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-always {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-always:hover {
        text-decoration-line: underline;
    }
    .nd-header .link._large {
        font-size: var(--font-large-font-size, 1.125rem);
        line-height: var(--font-large-line-height, 1.1112);
    }
    .nd-header .link._medium {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
    }
    .nd-header .link._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
    }
    .nd-header .link._extra-small {
        font-size: var(--font-small-font-size, 0.75rem);
        line-height: var(--font-small-line-height, 1.1667);
    }
    .nd-header .link._bold {
        font-weight: var(--bold-font-weight, 500);
    }
    .nd-header .link._primary-colored {
        color: var(--primary-color, #00dc00);
    }
</style>
<style>
    .button {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        font-weight: 500;
        line-height: normal;
        text-align: center;
        letter-spacing: 0.2px;
        white-space: nowrap;
        border-radius: 24px;
    }

    .button span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }

    .button._icon-right {
        flex-direction: row-reverse;
    }

    .button._icon-right svg {
        margin-left: 5px;
    }

    .button._icon-left svg:not(:last-child) {
        margin-right: 5px;
    }

    .button._large {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
        min-width: 88px;
        height: 32px;
        padding: 10px 16px;
    }

    .button._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        min-width: 72px;
        height: 28px;
        padding: 10px 16px;
        font-weight: 500;
    }

    .button._full-width {
        width: 100%;
    }

    .button._left-aligned-text {
        justify-content: flex-start;
    }

    .button._primary {
        color: var(--primary-text-color, #000000cc);
        background: var(--primary-color, #00dc00);
        border: none;
    }

    @media screen and (min-width:768px) {
        .button._primary:hover {
            background: var(--primary-hover-color, #00ff00);
        }
    }

    .button._primary:active {
        background: var(--primary-pressed-color, #00c200);
    }

    .button._primary._advantageCard {
        align-self: center;
        width: fit-content;
        font-size: 16px;
        font-weight: 400;
    }

    .button._secondary {
        color: #ffffffde;
        background: #323232;
        border: none;
    }

    @media screen and (min-width:768px) {
        .button._secondary:hover {
            background: #464646;
        }
    }

    .button._secondary:active {
        background: #515151;
    }

    .button._outlined {
        color: var(--primary-text-color, #000000cc);
        background-color: transparent;
        border: 2px var(--primary-text-color, #000000cc) solid;
    }

    @media screen and (min-width:768px) {
        .button._outlined:hover {
            background-color: #4637000f;
            background-blend-mode: multiply;
        }
    }

    .button._outlined:active {
        background-color: #4637001f;
        background-blend-mode: multiply;
    }

    .button._outlined._advantageCard {
        align-self: center;
        width: fit-content;
        font-size: 16px;
        font-weight: 400;
    }

    .button._disabled {
        pointer-events: none;
        cursor: auto;
        color: #00000061;
        background: #0000001e;
        border: none;
    }

    .button._loading {
        pointer-events: none;
        cursor: auto;
    }

    .button:focus-visible {
        outline: 2px dashed var(--primary-text-color, #000000cc);
        outline-offset: 2px;
    }

    .button._onlyIcon {
        min-width: 32px;
        height: 32px;
        padding: 0;
    }

    .button._customizedBackgroundColor {
        background-color: var(--custom-background-color, #00dc00);
    }

    .button._customizedBackgroundColor:active {
        background-color: var(--pressed-custom-background-color, #00ff00);
    }

    @media screen and (min-width:768px) {
         .button._customizedBackgroundColor:hover {
            background-color: var(--hover-custom-background-color, #00c200);
        }
    }
</style>
<style>
    :root {
        --nd-header-transition-time: 0.3s;
    }
    .nd-header * {
        box-sizing: border-box;
    }
    .nd-header ul,
    .nd-header ol,
    .nd-header dl {
        margin: 0;
        padding: 0;
    }
    .auth__avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        aspect-ratio: 1 / 1;
        width: 24px;

        font-size: 0.8125rem;
        color: #ffffffde;

        background-color: #3c3f34;
        border-radius: 50%;
    }
    .auth__avatar._primary {
        width: 40px;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
    }

    .auth-popup {
        display: none;
        position: absolute;
        top: 68px;
        right: 250px;
        background: #ffffff;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16),
            0 4px 12px rgba(0, 0, 0, 0.16);
        border-radius: 0 0 8px 8px;

        color: rgba(0, 0, 0, 0.87);
        min-width: 368px;
        cursor: default;
    }
    .auth-popup__wrapper {
        padding: 32px;
    }
    .auth-popup._opened {
        display: block;
    }

    .auth-popup__title {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
    }

    .auth-popup__name {
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;

        text-decoration-line: underline;
        color: rgba(0, 0, 0, 0.87);
    }

    .auth-popup__private-information {
        display: flex;
        gap: 16px;
        align-items: center;
        padding-block: 16px;
    }

    .auth-popup__button {
        margin-top: 16px;
        width: 82px;
        height: 40px;
        background: #00dc00;
        border-radius: 48px;
        border: none;
        letter-spacing: 0.2px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        cursor: pointer;
    }

    .auth__auth-button[hidden] {
        display: none;
    }

    .nd-header {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    .nd-header {
        font-family: YouNik, sans-serif;
        letter-spacing: 0.15px;
    }

    .nd-header a {
        text-decoration: none;
    }

    .nd-header button {
        font-family: inherit;
    }

    .nd-header {
        position: fixed;
        z-index: 1000;
        top: 0;
        right: 0;
        left: 0;
        background: #fff;
        font-family: "YouNik", sans-serif;
        font-size: 1rem;
        font-weight: 400;
        font-style: normal;
        font-feature-settings: "tnum";
        -webkit-font-smoothing: antialiased;
        transition: top var(--nd-header-transition-time);
    }

    .nd-header .nd-header__control._mobile-menu-toggle {
        display: none;
    }

    body._hiddenHeaderTop .nd-header {
        top: calc(0px - var(--nd-header-top-height));
    }

    body._hiddenHeaderTop #Coi-Renew {
        z-index: 1;
    }

    .nd-header__top {
        display: flex;
        align-items: center;
        background: #fff;
    }

    .nd-header__top-inner {
        width: 1200px;
    }

    .nd-header .page-limiter {
        max-width: 1200px;
        margin: 0 auto;
    }

    .nd-header__top-controls {
        display: flex;
        gap: 24px;
        align-items: center;
        justify-content: flex-end;
        font-size: 10px;
        color: #0000008f;
        line-height: 15px;
    }

    .nd-header__top-control {
        cursor: pointer;
        user-select: none;
        display: flex;
        gap: 9px;
        align-items: center;
    }
    .nd-header__top-control-link {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        line-height: 15px;
        color: #0000008f;
        text-decoration: none;
        align-items: center;
        letter-spacing: 0.15px;
    }

    .nd-header__top-control-link:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }

    .nd-header__top-control-image {
        margin-right: 8px;
    }

    .nd-header__middle {
        position: relative;
        display: flex;
        background: #fff;
    }

    .nd-header__middle._no-border {
        border-bottom-color: transparent;
    }

    .nd-header .nd-header__top-inner {
        margin: 12px auto 0;
        padding-bottom: 12px;
    }

    .nd-header .middle-page-limiter {
        margin: 21px auto 0;
        padding-bottom: 21px;
    }

    .nd-header__middle-inner {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-between;
    }

    .search__field-container.page-limiter.middle-page-limiter {
        margin: 12px auto 0;
        padding-bottom: 24px;
    }

    .nd-header__middle,
    .nd-header__top {
        border-bottom: 1px solid #0000001f;
    }

    .nd-header__left {
        display: flex;
    }

    .nd-header__go-back {
        display: none;
    }

    .nd-header__logo {
        display: flex;
        position: relative;
        margin-right: 40px;
    }

    .nd-header__logo._hidden {
        display: none;
    }

    .nd-header__logo-image {
        max-height: 52px;
    }

    .nd-header__logo-link {
        display: flex;
        align-items: center;
    }

    .nd-header__logo-link:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }

    .nd-header__links {
        display: flex;
        gap: 32px;
        padding-inline-start: 0;
    }

    .nd-header__controls {
        display: grid;
        grid-auto-flow: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-end;
    }

    .nd-header__controls._mobile {
        justify-content: flex-start;
    }

    .nd-header__control {
        cursor: pointer;
        user-select: none;
    }

    .nd-header__control-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .header__control-button._full-width {
        flex-grow: 1;
    }

    .search__container,
    .cart-min__cart-min {
        position: relative;
    }

    .search__container,
    .auth__auth-button,
    .cart-min__cart-min {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        background-color: transparent;
        border: 2px dashed transparent;
        padding: 0;
        height: 24px;
        width: 24px;
        justify-content: center;
        border-radius: 24px;
    }

    .search__icon {
        fill: rgba(0, 0, 0, 0.87);
    }

    .nd-header__control._search {
        position: relative;
    }

    .nd-header__control .search__container:hover,
    .nd-header__control .auth__auth-button:hover,
    .nd-header__control .cart-min__cart-min:hover {
        background-color: #4637000f;
    }

    .nd-header__control .search__container:focus-visible,
    .nd-header__control .auth__auth-button:focus-visible,
    .nd-header__control .cart-min__cart-min:focus-visible {
        background-color: #4637000f;
        border-color: #000000cc;
        outline: none;
    }

    .nd-header__search {
        position: absolute;
        width: 100%;
        bottom: -10px;
        display: none;
    }

    .search__field {
        position: relative;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 6px 6px 20px;
        border: 2px solid #000000cc;
        border-radius: 60px;
        background: #fff;

        transition: 0.4s;
        transform: translateX(1000px);
        opacity: 0;
    }

    .search__field._opened {
        transform: translateX(0);
        opacity: 1;
    }

    .search__field-container-inner {
        margin: 0 66px 0 120px;
    }

    .search__field-components {
        position: relative;
        overflow: hidden;
    }

    .search__field-icon {
        width: 32px;
        height: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 0;
        background: #fff;
        outline: none;
        border: none;
        border-radius: 32px;
        cursor: pointer;
    }

    .search__field-icon._cross:hover,
    .search__field-icon._cross:focus {
        background: #4637000f;
    }

    .search__field-icon._cross:active {
        background: #4637001f;
    }

    .search__field-icon._cross:focus-visible {
        outline: 2px dashed #000000cc;
    }

    .search__field-icon._search {
        position: absolute;
        top: 8px;
        right: 6px;
        cursor: default;
        border-radius: 16px;

        display: none;
    }

    .search__field-icon-separator {
        width: 1px;
        height: 32px;
        margin-right: 35px;

        background-color: #221f0e3b;
    }

    .search__icon {
        fill: #000000cc;
    }

    .search__input {
        width: 100%;
        padding: 0;

        font-family: "YouNik", sans-serif;
        color: #000000cc;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.5px;
        caret-color: #00dc00;

        outline: none;
        border: none;
    }

    .search__input::placeholder {
        color: #0000008f;
    }

    .search__label {
        flex-grow: 1;
    }

    .search__suggestions-container {
        position: relative;
        width: 100%;
    }

    .search__suggestions {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        background-color: #fff;
        padding: 56px 0 30px;
        border-radius: 24px;
        border: 1px #221f0e3b solid;
        box-sizing: border-box;
        overflow: hidden;
    }

    .search__suggestions:empty {
        padding: 0;
        border: none;
    }

    .search__suggestion {
        display: block;
        padding: 4px 16px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        cursor: pointer;
    }

    .search__suggestion,
    .search__suggestion:active,
    .search__suggestion:visited {
        color: #000000cc;
    }

    .search__suggestion:focus,
    .search__suggestion:focus-visible,
    .search__suggestion:hover {
        background: #4637000f;
    }

    .search__suggestion:focus-visible {
        outline: 2px dashed #000000cc;
        outline-offset: -2px;
    }

    .cart-min__desktop {
        display: block;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .nd-header__go-back._hidden {
        display: none;
    }

    .nd-header__title {
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
    }

    .nd-header__controls._web-view {
        display: flex;
    }

    .nd-header .label {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #323232;
    }

    .nd-header__right {
        display: flex;
        flex-direction: row;
        gap: 16px;
    }

    .nd-header__right > .label {
        display: none;
    }

    .menu_back_buttons._hidden {
        display: none;
    }

    @media screen and (min-width: 1025px) and (max-width: 1309px) {
        .nd-header .page-limiter {
            padding-inline: 24px;
        }
    }

    @media screen and (min-width: 1025px) and (max-width: 1309px) {
        .nd-header + .bg {
            display: block;
        }
    }

    @media screen and (max-width: 1024px) {
        .nd-header .page-limiter {
            padding-inline: 16px;
        }

        .nd-header ._desktop {
            display: none;
        }

        .nd-header .nd-header__control._mobile-menu-toggle {
            display: flex;
            justify-content: center;
            gap: 16px;
        }

        .nd-header + .bg {
            display: block;
            margin-top: 68px;
        }

        .nd-header__top {
            display: none;
        }

        .nd-header__top-controls {
            display: none;
        }

        .nd-header__middle {
            height: 68px;
            width: 100%;
        }

        .nd-header__middle.menu-active {
            border-bottom-color: transparent;
        }

        .nd-header__middle[data-active-level="1"] .go-back-to-1,
        .nd-header__middle[data-active-level="2"] .go-back-to-2 {
            display: flex;
        }

        .nd-header__middle[data-active-level="1"] .nd-header__logo,
        .nd-header__middle[data-active-level="2"] .nd-header__logo {
            display: none;
        }

        .nd-header__logo {
            display: flex;
            flex: 1 1 auto;
            justify-content: center;
            align-items: center;
            margin-right: 16px;
        }

        .nd-header__links {
            display: grid;
            grid-auto-flow: column;
            grid-column-gap: 48px;
            margin: 0 50px;
        }

        .nd-header__controls {
            flex: 1 1 0;
            gap: 16px;
        }

        .nd-header__control._mobile-menu-toggle > button {
            width: 24px;
            height: 24px;
        }

        ._mobile-second {
            grid-column: 2;
        }
        ._mobile-second._hidden {
            display: none;
        }

        .nd-header__right > .label {
            position: relative;
            display: flex;
        }
    }

    .popover-overlay {
        position: fixed;
        z-index: -1;
        inset: 0;
        background: #0f140a66;
        width: 100%;
        height: 100%;
        visibility: hidden;
    }

    .popover-overlay._open {
        visibility: visible;
    }

    @media screen and (max-width: 767px) {
        .auth-popup {
            width: 100%;
            box-shadow: none;
            border-radius: unset;
        }
        .auth-popup__wrapper {
            width: 100%;
            box-shadow: none;
            padding: 24px;
            height: calc(100vh - var(--nd-total-header-height));
        }
        .auth-popup__title {
            font-size: 16px;
            line-height: 24px;
        }

        .auth-popup__name {
            font-size: 16px;
            line-height: 24px;
        }

        .auth-popup__button {
            margin-top: 40px;
        }
        .nd-header__logo._hideInWebView {
            display: none;
        }

        .nd-header__go-back {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: transparent;
            border: none;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 375px) {
        .auth-popup {
            top: 50px;
        }
        .nd-header__middle {
            height: 50px;
        }

        .nd-header + .bg {
            margin-top: 50px;
        }
    }
</style>
<style>
    .nav-menu__item-wrapper {
        text-decoration: none;
        display: flex;
        align-items: flex-start;
        align-self: center;
        white-space: nowrap;
    }

    .nav-menu__item-container {
        position: absolute;
        top: 68px;
        left: 0;
        right: 0;
        background: #ffffff;
        min-height: 300px;
        visibility: hidden;
        padding: 32px;
        overflow: auto;
        display: block;
        max-height: calc(100vh - 108px);
        scrollbar-gutter: stable both-edges;
    }
    .nav-menu__item-wrapper._hover .nav-menu__item-container,
    .nav-menu__item-wrapper._leaving .nav-menu__item-container {
        visibility: visible;
    }
    .nav-menu__label {
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        line-height: 15px;
        color: #000000cc;
        white-space: nowrap;
        text-decoration: none;
        background-color: transparent;
        border: 0;
        border-bottom: #ffffff 2px solid;
    }
    ._hover .nav-menu__label,
    ._leaving .nav-menu__label {
        border-bottom: #000000cc 2px solid;
    }
    .nav-menu__label:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }
    .nav-menu__item-inner {
        display: flex;
        gap: 24px;
        justify-content: space-between;
    }
    .nav-menu__groups-section {
        display: flex;
        gap: 24px;
        flex-wrap: wrap;
    }
    .nav-menu__group {
        width: 220px;
        white-space: initial;
    }
    .nav-menu__group-title {
        font-family: "YouNik", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #a2a2a2;
        padding: 0 0 16px 0;
        text-align: left;
    }
    .nav-menu__links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 8px;
    }
    .nav-menu__link-wrapper {
        display: block;
    }
    .nav-menu__link {
        letter-spacing: 0.3px;
    }

    .nav-menu__shortcuts-section {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        min-width: 130px;
        color: pink;
        list-style-type: none;
    }
    .nav-menu__shortcut-wrapper {
        display: flex;
        text-align: right;
        margin-bottom: 16px;
    }
    .nav-menu__shortcut {
        justify-content: flex-end;
        flex-direction: row;
        gap: 6px;
        margin-left: 4px;
    }

    @media screen and (min-width: 1025px) and (max-width: 1309px) {
        .nav-menu__item-inner.page-limiter {
            margin: 0;
        }
    }
</style>
<script>
    function debounce(func, timeout = 300) {
        let timer;

        return function(...args) {
            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(function() {
                func.apply(this, args);
            }, timeout);
        };
    }
</script>

<header class="nd-header">
        <div class="nd-header__top">
            <div class="nd-header__top-inner page-limiter">
                <div class="nd-header__top-controls">
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://musik.yousee.dk" >
                                YouSee Musik
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://play.yousee.dk" >
                                YouSee Play
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://sentry-authn.yousee.dk/oauth/authorize?client_id=zimbra-webmail-prod&amp;redirect_uri=https%3A%2F%2Fmityousee-odinapi.yousee.dk%2Fyousee%2Fselfcare%2Fprofile%2Fdelegated-authenticate%2Fwebmail%2Ftokens&amp;response_type=code" >
                                Webmail
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://yousee.dk/hjaelp/kontakt" >
                                Kontakt os
                            </a>
                        </div>
                </div>
            </div>
        </div>
    <div class="nd-header__middle jsMiddleMenu ">
        <div class="nd-header__middle-inner page-limiter middle-page-limiter">
            <div class="nd-header__left">
                    <div class="nd-header__logo">
                        <a
                            class="nd-header__logo-link jsNavLogoLink"
                            href="https://yousee.dk"
                        >
                            <img
                                class="nd-header__logo-image _full"
                                src="https://yousee.dk/shop/images/nuuday/yousee-logo.svg"
                                width="91"
                                height="26"
                                alt="YouSee"
                            />
                        </a>
                    </div>
                    <div class="menu_back_buttons _hidden jsMenuButtons">

<button
	type="button"
	class="mobile-menu__go-back go-back-to-1 jsMenuButtonBack"
	title="Tilbage"
	role="button"
>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M14.1401 18.9982H16.5C15.3113 15.8513 13.0077 13.3187 10.1203 11.9798C12.996 10.6463 15.2939 8.13032 16.4864 5H14.1226C12.6625 8.17998 9.83139 10.4569 6.5 10.8689V13.0925C9.84497 13.5045 12.6858 15.7998 14.142 19L14.1401 18.9982Z" fill="black" fill-opacity="0.8"/>
	</svg>
</button>
<button
	type="button"
	class="mobile-menu__go-back go-back-to-2 jsMenuButtonBack"
	title="Tilbage"
	role="button"
>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M14.1401 18.9982H16.5C15.3113 15.8513 13.0077 13.3187 10.1203 11.9798C12.996 10.6463 15.2939 8.13032 16.4864 5H14.1226C12.6625 8.17998 9.83139 10.4569 6.5 10.8689V13.0925C9.84497 13.5045 12.6858 15.7998 14.142 19L14.1401 18.9982Z" fill="black" fill-opacity="0.8"/>
	</svg>
</button>                    </div>
                    <ul class="nd-header__links _desktop nav-menu">

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Mobil</button>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobiltelefoner</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner"

>
                                                        Alle mobiltelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/tilbud"

>
                                                        Tilbud på mobiltelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/apple"

>
                                                        De nyeste iPhones

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/samsung"

>
                                                        Det nyeste fra Samsung

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/restsalg?category=handsets"

>
                                                        Restsalg

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/god-begyndermobil"

>
                                                        Gode begyndermobiler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobilabonnementer</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                                                        Alle mobilabonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/roaming"

>
                                                        Roaming

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"

>
                                                        Datapakker

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/musik"

>
                                                        YouSee Musik

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/mobiltilvalg"

>
                                                        Ring til udlandet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tilbehør til mobil</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoeretelefoner"

>
                                                        Høretelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoejttalere"

>
                                                        Højttalere

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets"

>
                                                        Tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches"

>
                                                        Smartwatches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/covers"

>
                                                        Covers

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=wallets"

>
                                                        Wallets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=screen protection"

>
                                                        Skærmbeskyttelse

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=charges and cables"

>
                                                        Oplader &amp; kabler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        Danmarks bedste mobilnet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/den-første-mobil"

>
                                                        Den første mobil

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/bytterabat"

>
                                                        Bytterabat

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Se dækningskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/mobil"
        target="_blank"
    
>
                                            Hjælp til mobil

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Internet</button>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Internet til hjemmet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/internet"

>
                                                        Alle internet-abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/internet/fibernet"

>
                                                        Fibernet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/internet/coax"

>
                                                        Internet via antennestikket

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/internet/5g-internet"

>
                                                        5G-internet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobilt Internet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                                                        Mobilt internetabonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/internet-i-sommerhuset"

>
                                                        Internet i sommerhuset

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Se dækningskort

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tilbehør til internet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/mesh"

>
                                                        Mesh node

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets"

>
                                                        Tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?sort=popularity-asc&amp;installments=none&amp;category=broadband fixed accessories"

>
                                                        Tilbehør til internet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/internet"

>
                                                        Hvilken hastighed skal jeg vælge?

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                                        Tjek din hastighed

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/mit-internet"

>
                                                        Sikkerhed i hjemmet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/digitalsikkerhed"

>
                                                        Digital sikkerhed

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/flytadresse"

>
                                                        Flyt adresse

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/internet"
        target="_blank"
    
>
                                            Hjælp til internet

</a>
                                </li>
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/mobilt-internet"
        target="_blank"
    
>
                                            Hjælp til mobilt internet

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Tv &amp; streaming </button>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tv-abonnementer</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tv"

>
                                                        Alle tv-abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tv/yousee-play"

>
                                                        YouSee Play abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tv/tv-pakker"

>
                                                        Fast tv-pakke abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/foreninger"

>
                                                        Foreningsaftaler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Alle streamingtjenester og kanaler</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/yousee-play/kanaloverblik"

>
                                                        Alle streamingtjenester og kanaler

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/netflix"

>
                                                        Netflix

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tv2play"

>
                                                        TV 2 Play

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/viaplay"

>
                                                        Viaplay

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/disneyplus"

>
                                                        Disney+

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hbo-max"

>
                                                        HBO Max

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/prime-video"

>
                                                        Prime Video

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Udstyr til tv &amp; streaming</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/audio"

>
                                                        Audio

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/streamer"

>
                                                        Streamer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tv-boksen"

>
                                                        Tv-boks

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/play-appen"

>
                                                        App - altid inkluderet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/premiere"

>
                                                        YouSee Premiere

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://play.yousee.dk/tv-guide"

>
                                                        Tv-guide

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/sport"

>
                                                        Sport i tv

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/premier-league"

>
                                                        Ugens Premier League-kampe

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "
        target="_blank"
    
>
                                            Hjælp til tv &amp; streaming

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Watches &amp; tablets</button>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Find watches &amp; tablets</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches"

>
                                                        Alle smartwatches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches/apple"

>
                                                        Apple watches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches/samsung"

>
                                                        Samsung watches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets"

>
                                                        Alle tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets/tilbud"

>
                                                        Tilbud på tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets/apple"

>
                                                        iPads

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/restsalg?category=smart watches;tablets;premium accessories;bluetooth headset"

>
                                                        Restsalg

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Abonnement til watches &amp; tablets</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                                                        Mobilabonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                                                        Mobilt internetabonnementer

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        Danmarks bedste mobilnet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Se dækningskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"
        target="_blank"
    
>
                                            Hjælp til smartwatch

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Tilbehør</button>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Alt tilbehør</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer"

>
                                                        Alt tilbehør

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer/tilbud"

>
                                                        Tilbud på tilbehør

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=premium accessories"

>
                                                        Tilbehør med mobilabonnement

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/restsalg?category=smart watches;tablets;premium accessories;bluetooth headset"

>
                                                        Restsalg

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tilbehørskategorier</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoeretelefoner"

>
                                                        Høretelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoejttalere"

>
                                                        Højttalere

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=screen protection"

>
                                                        Skærmbeskyttelse

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/covers"

>
                                                        Covers

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=wallets"

>
                                                        Wallets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=charges and cables"

>
                                                        Opladere og kabler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://musik.yousee.dk"

>
                                                        YouSee Musik

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch abonnementer

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <a href="https://yousee.dk/hjaelp" class="nav-menu__label jsNavMenuLabel">Hjælp</a>
            <div class="nav-menu__item-container jsNavMenuItemContainer">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mest læste artikler</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/mit-internet-virker-ikke"

>
                                                        Mit internet virker ikke

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/sadan-skifter-du-betalingskort"

>
                                                        Sådan skifter du betalingskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"

>
                                                        Tag mobilen med på rejsen

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/sadan-ser-du-tv-og-film-pa-app-og-web"

>
                                                        Sådan ser du tv og film med YouSee Play

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tilknyt-din-yousee-mail-til-mit-yousee-login"

>
                                                        Tilknyt din YouSee Mail til Mit YouSee-login

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Hjælp til produkter</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/tv-og-streaming"

>
                                                        Tv &amp; Streaming

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/internet"

>
                                                        Internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mail"

>
                                                        Mail

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mobil"

>
                                                        Mobil

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mobilt-internet"

>
                                                        Mobilt Internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/fastnet"

>
                                                        Fastnet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/yousee-musik"

>
                                                        YouSee Musik

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Hjælp til regning og konto</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/regning-og-betaling"

>
                                                        Regning &amp; betaling

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/login-og-mit-yousee"

>
                                                        Login &amp; Mit YouSee

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/sikkerhed-pa-nettet"

>
                                                        Sikkerhed på nettet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"

>
                                                        Vilkår &amp; abonnement

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Andet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Tjek driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                                        Tag hastighedstest

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/butik"

>
                                                        Find YouSee butik

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
class="button _outlined _small _icon-right    nav-menu__shortcut"
style="
    "
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp"
        target="_blank"
    
>
                                            Find mere hjælp

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>

<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <a href="https://selvbetjening.yousee.dk" class="nav-menu__label jsNavMenuLabel">Mit YouSee</a>
    </div>
</li>
                    </ul>
                <div class="popover-overlay jsNavMenuOverlay"></div>
            </div>
                <div class="nd-header__right">
                    <div class="nd-header__controls ">
                            <div class="nd-header__control _desktop">
                                <button type="button" class="search__container jsSearchOpen" title="Søg" role="button">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.668 13.833C11.6928 14.5659 10.4805 15.0002 9.16671 15.0002C5.94505 15.0002 3.33337 12.3885 3.33337 9.16683C3.33337 5.94517 5.94505 3.3335 9.16671 3.3335C12.3884 3.3335 15 5.94517 15 9.16683C15 10.4771 14.568 11.6865 13.8387 12.6603L17.7226 16.5442H15.4167L12.668 13.833ZM13.3334 9.16683C13.3334 11.468 11.4679 13.3335 9.16671 13.3335C6.86552 13.3335 5.00004 11.468 5.00004 9.16683C5.00004 6.86564 6.86552 5.00016 9.16671 5.00016C11.4679 5.00016 13.3334 6.86564 13.3334 9.16683Z" fill="black" fill-opacity="0.8"/>
                                    </svg>
                                </button>
                            </div>
                        <div class="nd-header__control _mobile-second " data-component="MinCartContainer">
                            <div class="cart-min__desktop">
                                    <a href="https://yousee.dk/shop/kurv" class="cart-min__cart-min" title="Gå til kurv">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.66675 4.99984C7.66675 3.71117 8.71142 2.6665 10.0001 2.6665C11.2887 2.6665 12.3334 3.71117 12.3334 4.99984V5.83317H7.66675V4.99984ZM5.66675 7.83317V8.33317C5.66675 8.88546 6.11446 9.33317 6.66675 9.33317C7.21903 9.33317 7.66675 8.88546 7.66675 8.33317V7.83317H12.3334V8.33317C12.3334 8.88546 12.7811 9.33317 13.3334 9.33317C13.8857 9.33317 14.3334 8.88546 14.3334 8.33317V7.83317H16.3334V13.4998C16.3334 14.6044 15.438 15.4998 14.3334 15.4998H5.66675C4.56218 15.4998 3.66675 14.6044 3.66675 13.4998V7.83317H5.66675ZM5.66675 5.83317V4.99984C5.66675 2.6066 7.60685 0.666504 10.0001 0.666504C12.3933 0.666504 14.3334 2.6066 14.3334 4.99984V5.83317H16.3334H18.3334V7.83317V13.4998C18.3334 15.709 16.5426 17.4998 14.3334 17.4998H5.66675C3.45761 17.4998 1.66675 15.709 1.66675 13.4998V7.83317V5.83317H3.66675H5.66675Z" fill="black" fill-opacity="0.8"/>
                                        </svg>
                                    </a>
                                <div class="popoverCartMinContainer"></div>
                            </div>
                        </div>
                        <div class="nd-header__control taAuthIcon jsAuthIcon _mobile" data-component="AuthContainer">
                            <div class="auth__authContainer">
                                    <section class="auth-popup jsPopup">
                                        <div class="auth-popup__wrapper">
                                            <h2 class="auth-popup__title">Du er logget ind</h2>
                                            <div class="auth-popup__private-information jsPrivateInformation">
                                                <div class="auth__avatar _primary jsAvatar">
                                                    
                                                </div>
                                                <u class="auth-popup__name">
                                                    <span class="auth-popup__firstName jsFirstName"></span>
                                                    <span class="auth-popup__lastName jsLastName"></span>
                                                </u>
                                            </div>
                                            <button class="auth-popup__button jsLogOutButton" type="button"
                                                    title="Log ud"
                                                    role="button">Log ud</button>
                                        </div>
                                    </section>
                                <button type="button"
                                        class="auth__auth-button jsUserButton"
                                        hidden
                                        title="Log ind" role="button">
                                    <div class="auth__popover-anchor"></div>
                                    <div
                                        class="auth__avatar jsAvatar">
                                    </div>
                                </button>
                                <button type="button"
                                        
                                        class="auth__auth-button jsLogInButton"
                                        
                                        title="Log ind" role="button">
                                    <div class="auth__popover-anchor"></div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91979 2C7.13885 2 4.83325 4.1958 4.83325 6.96667C4.83325 9.73754 7.13885 11.9333 9.91979 11.9333C12.7007 11.9333 15.0063 9.73754 15.0063 6.96667C15.0063 4.1958 12.7007 2 9.91979 2ZM6.83325 6.96667C6.83325 5.35608 8.18687 4 9.91979 4C11.6527 4 13.0063 5.35608 13.0063 6.96667C13.0063 8.57726 11.6527 9.93333 9.91979 9.93333C8.18687 9.93333 6.83325 8.57726 6.83325 6.96667ZM9.99992 12.3333C8.09536 12.3333 6.23251 12.5975 4.81097 13.3647C4.08664 13.7556 3.45651 14.2883 3.01033 14.9986C2.56165 15.713 2.33325 16.5528 2.33325 17.4999C2.33325 18.0522 2.78097 18.4999 3.33325 18.4999C3.88554 18.4999 4.33325 18.0522 4.33325 17.4999C4.33325 16.8845 4.47795 16.4223 4.70397 16.0624C4.9325 15.6986 5.27868 15.3849 5.76078 15.1247C6.7521 14.5898 8.22257 14.3333 9.99992 14.3333C11.7773 14.3333 13.2477 14.5898 14.2391 15.1247C14.7212 15.3849 15.0673 15.6986 15.2959 16.0624C15.5219 16.4223 15.6666 16.8845 15.6666 17.4999C15.6666 18.0522 16.1143 18.4999 16.6666 18.4999C17.2189 18.4999 17.6666 18.0522 17.6666 17.4999C17.6666 16.5528 17.4382 15.713 16.9895 14.9986C16.5433 14.2883 15.9132 13.7556 15.1889 13.3647C13.7673 12.5975 11.9045 12.3333 9.99992 12.3333Z" fill="black" fill-opacity="0.8"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="nd-header__control _mobile-menu-toggle">

<style>
    .header__control-button,
    .mobile-menu__go-back,
    .ecare-mobile-menu__go-back{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
    }

    .mobile-menu__go-back,
    .header__control-button._hidden {
        display: none;
    }

    ._active-nav-menu .header__left,
    ._active-nav-menu:has(.ecare-mobile-menu__go-back[style="display: flex"]) ._mobile-second,
    ._active-nav-menu:has(.ecare-mobile-menu__go-back[style="display: flex"]) ._mobile {
        display: none;
    }

    ._active-nav-menu  .header__controls {
        display: flex;
    }

    ._active-nav-menu  .header__right {
        flex-grow: 1;
    }

    ._active-nav-menu .nd-header__control._mobile-menu-toggle {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
    }

    .mobile-menu__popover {
        position: fixed;
        top: 68px;
        left: 0;
        right: 0;
        background-color: #fff;
        height: calc(100% - 68px);
        flex-direction: column;
        justify-content: space-between;
        overflow: auto;
        display: none;
        visibility: hidden;
        opacity: 0;
        width: 100vw;
    }

    @media screen and (max-width:375px) {
        .mobile-menu__popover {
            top: 50px;
            height: calc(100% - 50px);
        }
    }

    .mobile-menu__popover._visible {
        display: flex;
        visibility: visible;
        opacity: 1;
        transition: 200ms ease-out opacity;
        z-index: 10;
    }

    .mobile-menu__inner {
        padding: 24px 16px 0;
    }

    .mobile-menu__bottom {
        padding-bottom: 16px;
    }

    .mobile-menu-search {
        margin-bottom: 32px;
        width: 100%;
        background-color: #FFF;
        border-radius: 24px;
        border: 1px #221f0e3b solid;
        border-top: none;
        overflow: hidden;
        flex-direction: column;
    }

    .mobile-menu-search._empty {
        border: none;
    }

    .mobile-menu-search__field {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 8px 0 20px;
        height: 48px;
        border: 1px solid rgba(0, 0, 0, 0.23);
        border-radius: 60px;
        caret-color: #00DC00;
    }

    .mobile-menu-search__suggestions {
        margin: 8px 0 30px;
    }

    ._active-search .mobile-menu-search__field {
        border: 2px solid #000000cc;
    }

    .mobile-menu-search__suggestions:empty {
      margin: 0;
    }


    .mobile-menu-search__suggestion:last-child {
      margin-bottom: 12px;
    }

    .mobile-menu__nav-menu._hidden {
        display: none;
    }

    .mobile-menu__ecare-nav-menu._hidden {
        display: none;
    }

    ._active-search .mobile-menu__nav-menu,
    ._active-search .header__bottom-links{
        display: none;
    }

    .mobile-menu-search__input {
        border: none;
        display: flex;
        flex-grow: 1;
        font-weight: 400;
        font-size: 14px;
        font-family: "YouNik", sans-serif;
        line-height: 15px;
        align-items: center;
        letter-spacing: 0.5px;
        color: rgba(0, 0, 0, 0.87);
    }

    .mobile-menu-search__input:focus-visible {
        outline: none;
    }

    .mobile-menu-search__close-container {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .mobile-menu-search._empty .mobile-menu-search__close-container {
        opacity: 0;
    }

    .mobile-menu-search__separator {
        display: block;
        margin-right: 4px;
        width: 1px;
        height: 24px;
        background-color: rgba(0, 0, 0, 0.23);
    }

    button.mobile-menu-search__button {
        background: none;
        border: none;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button.mobile-menu-search__button._cross {
        cursor: pointer;
    }

    .mobile-menu-search__input::placeholder,
    .mobile-menu-search__input:-ms-input-placeholder,
    .mobile-menu-search__input::-ms-input-placeholder{
        color: rgba(0, 0, 0, 0.87);
        opacity: 1; /* Firefox */
    }

    .list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 16px;
        padding: 20px 0;
        list-style: none;
    }

    .mobile-menu__label {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: none;
        border: 0;
        width: 100%;
        cursor: pointer;
        padding: 0;
    }

    .mobile-menu__label-arrow {
        margin-inline: 4px;
    }

    .mobile-menu__links-group {
        display: none;
    }

    .list-item > .mobile-menu__label,
    .list-item > .mobile-menu__link {
        padding-block: 15px;
    }

    .list-item._active {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        padding: 16px;
    }

    .list-item._active > .mobile-menu__label {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.87);
        padding-block: 8px;
        letter-spacing: 0.15px;
    }

    .list-item._active > .mobile-menu__label .mobile-menu__label_arrow {
        display: none;
    }

    .list-item._active > .mobile-menu__label .mobile-menu__nav-link {
        font-size: 23px;
        line-height: 24px;
        cursor: default;
        pointer-events: none;
    }

    .list-item._active > .list {
        display: flex;
        padding: 16px 0;
        cursor: pointer;
    }

    .list-item .header__shortcuts {
        display: none;
    }

    .list-item._active > .header__shortcuts {
        display: flex;
        margin-top: auto;
        padding-bottom: 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .header__shortcut {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 5px 56px 5px 16px;
        border: 2px solid rgba(0, 0, 0, 0.87);
        border-radius: 24px;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0.2px;
        color: rgba(0, 0, 0, 0.87);
    }

    .mobile-menu__links {
        display: none;
    }

    .mobile-menu__link,
    .mobile-menu__nav-link {
        color: rgba(0, 0, 0, 0.87);
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.15px;
        text-decoration-line: none;
    }

    .mobile-menu__link {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;
    }

    .header__bottom-links {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 24px;
        padding-top: 16px;
        padding-bottom: 16px;
        scrollbar-width: none;
        overflow-x: auto;
        flex-flow: row nowrap;
    }

    .header__bottom-links ::-webkit-scrollbar {
        display: none;
    }

    .header__bottom-link {
        display: flex;
        gap: 16px;
        align-items: center;
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        white-space: nowrap;
        flex-direction: column;
    }

    .header__bottom-link:first-of-type {
        margin-left: 16px;
    }

    .header__bottom-link:last-of-type {
        margin-right: 16px;
    }

    .header__bottom-link-icon-container {
        margin: 0;
        padding-inline: 4px;
    }

    .cart-min__cart-min._hidden {
        display: none;
    }
</style>

    <button type="button" class="header__control-button _full-width jsMenuButtonOpen" title="Menu" role="button">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83325 5.83325H14.1666" stroke="black" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round"/>
            <path d="M5.83325 14.1667H14.1666" stroke="black" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round"/>
            <path d="M4.16675 10H15.8334" stroke="black" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </button>
<button type="button" class="ecare-mobile-menu__go-back" id="jsEcareNavMenuButtonBack" title="Tilbage" role="button" style="display: none;">
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53561 14.9311C8.14489 15.3214 7.51173 15.3211 7.1214 14.9304L0.939959 8.74272C0.755107 8.57439 0.633605 8.33769 0.615418 8.0726C0.595629 7.79366 0.692301 7.508 0.905434 7.29466L7.1214 1.07243C7.51173 0.681714 8.14489 0.681395 8.53562 1.07172C8.92634 1.46205 8.92665 2.09522 8.53633 2.48594L4.02366 7.00314L18.5019 7.00315C19.0542 7.00315 19.5019 7.45086 19.5019 8.00315C19.5019 8.55543 19.0542 9.00315 18.5019 9.00315L4.02713 9.00314L8.53633 13.5169C8.92665 13.9076 8.92633 14.5408 8.53561 14.9311Z" fill="black" fill-opacity="0.87"/>
    </svg>
</button>
<button type="button" class="header__control-button _full-width jsMenuButtonClose _hidden" title="Luk" role="button" id="jsMenuButtonClose">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8327 14.593L11.227 9.99956L15.822 5.39385L14.592 4.16699L9.99858 8.7727L5.39288 4.17771L4.16602 5.40764L8.77172 10.0026L4.17674 14.6083L5.40666 15.8337L10.0016 11.228L14.6074 15.8229L15.8327 14.593Z" fill="black" fill-opacity="0.8"/>
    </svg>
</button>
<div class="mobile-menu__popover jsMobileMenuPopover">
    <div class="mobile-menu__inner">
            <div class="mobile-menu-search _empty jsMobileMenuSearch">
                <div class="mobile-menu-search__field">
                    <input class="mobile-menu-search__input jsMobileMenuSearchInput" type="text" placeholder="Søg">
                    <span class="mobile-menu-search__close-container _empty jsMobileSearchCloseContainer">
                        <button type="button"
                            class="mobile-menu-search__button _cross jsMobileSearchClose"
                            role="button"
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8337 14.593L11.228 9.99956L15.8229 5.39385L14.593 4.16699L9.99956 8.7727L5.39385 4.17771L4.16699 5.40764L8.7727 10.0026L4.17771 14.6083L5.40764 15.8337L10.0026 11.228L14.6083 15.8229L15.8337 14.593Z" fill="black" fill-opacity="0.8"/>
                                </svg>
                        </button>
                        <span class="mobile-menu-search__separator"></span>
                    </span>
                    <button type="button" class="mobile-menu-search__button" title="Søg" role="button">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6676 13.8325C11.6925 14.5654 10.4801 14.9997 9.16634 14.9997C5.94468 14.9997 3.33301 12.388 3.33301 9.16634C3.33301 5.94468 5.94468 3.33301 9.16634 3.33301C12.388 3.33301 14.9997 5.94468 14.9997 9.16634C14.9997 10.4766 14.5677 11.686 13.8383 12.6598L17.7222 16.5437H15.4163L12.6676 13.8325ZM13.333 9.16634C13.333 11.4675 11.4675 13.333 9.16634 13.333C6.86516 13.333 4.99967 11.4675 4.99967 9.16634C4.99967 6.86516 6.86516 4.99967 9.16634 4.99967C11.4675 4.99967 13.333 6.86516 13.333 9.16634Z" fill="black" fill-opacity="0.8"/>
                        </svg>
                    </button>
                </div>
                <div class="mobile-menu-search__suggestions jsSearchMobileSuggestions"></div>
            </div>


        <nav class="mobile-menu">
                <ul class="mobile-menu__nav-menu jsNavMenu list" data-level="1">

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Mobil</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobiltelefoner</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner"  >
                                            Alle mobiltelefoner
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/tilbud"  >
                                            Tilbud på mobiltelefoner
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/apple"  >
                                            De nyeste iPhones
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/samsung"  >
                                            Det nyeste fra Samsung
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/restsalg?category=handsets"  >
                                            Restsalg
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/god-begyndermobil"  >
                                            Gode begyndermobiler
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobilabonnementer</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilabonnement"  >
                                            Alle mobilabonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/roaming"  >
                                            Roaming
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"  >
                                            Datapakker
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/musik"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/mobiltilvalg"  >
                                            Ring til udlandet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tilbehør til mobil</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoeretelefoner"  >
                                            Høretelefoner
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoejttalere"  >
                                            Højttalere
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets"  >
                                            Tablets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches"  >
                                            Smartwatches
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/covers"  >
                                            Covers
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=wallets"  >
                                            Wallets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=screen protection"  >
                                            Skærmbeskyttelse
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=charges and cables"  >
                                            Oplader &amp; kabler
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            Danmarks bedste mobilnet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/den-første-mobil"  >
                                            Den første mobil
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/bytterabat"  >
                                            Bytterabat
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Se dækningskort
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til mobil</span>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Internet</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Internet til hjemmet</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/internet"  >
                                            Alle internet-abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/internet/fibernet"  >
                                            Fibernet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/internet/coax"  >
                                            Internet via antennestikket
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/internet/5g-internet"  >
                                            5G-internet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobilt internet</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobilt Internet</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilt-internet"  >
                                            Mobilt internetabonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/internet-i-sommerhuset"  >
                                            Internet i sommerhuset
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Se dækningskort
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobilt internet</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tilbehør til internet</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/mesh"  >
                                            Mesh node
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets"  >
                                            Tablets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?sort=popularity-asc&amp;installments=none&amp;category=broadband fixed accessories"  >
                                            Tilbehør til internet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobilt internet</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/internet"  >
                                            Hvilken hastighed skal jeg vælge?
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/hastighedstest"  >
                                            Tjek din hastighed
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/mit-internet"  >
                                            Sikkerhed i hjemmet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/digitalsikkerhed"  >
                                            Digital sikkerhed
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/flytadresse"  >
                                            Flyt adresse
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobilt internet</span>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til internet</span>
                            </a>
                            <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til mobilt internet</span>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Tv &amp; streaming </span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tv-abonnementer</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tv"  >
                                            Alle tv-abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tv/yousee-play"  >
                                            YouSee Play abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tv/tv-pakker"  >
                                            Fast tv-pakke abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/foreninger"  >
                                            Foreningsaftaler
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Alle streamingtjenester og kanaler</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/yousee-play/kanaloverblik"  >
                                            Alle streamingtjenester og kanaler
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/netflix"  >
                                            Netflix
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tv2play"  >
                                            TV 2 Play
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/viaplay"  >
                                            Viaplay
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/disneyplus"  >
                                            Disney+
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hbo-max"  >
                                            HBO Max
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/prime-video"  >
                                            Prime Video
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Udstyr til tv &amp; streaming</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/audio"  >
                                            Audio
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/streamer"  >
                                            Streamer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tv-boksen"  >
                                            Tv-boks
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/play-appen"  >
                                            App - altid inkluderet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/premiere"  >
                                            YouSee Premiere
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://play.yousee.dk/tv-guide"  >
                                            Tv-guide
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/sport"  >
                                            Sport i tv
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/premier-league"  >
                                            Ugens Premier League-kampe
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Watches &amp; tablets</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Find watches &amp; tablets</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches"  >
                                            Alle smartwatches
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches/apple"  >
                                            Apple watches
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches/samsung"  >
                                            Samsung watches
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets"  >
                                            Alle tablets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets/tilbud"  >
                                            Tilbud på tablets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets/apple"  >
                                            iPads
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/restsalg?category=smart watches;tablets;premium accessories;bluetooth headset"  >
                                            Restsalg
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til smartwatch</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Abonnement til watches &amp; tablets</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilabonnement"  >
                                            Mobilabonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilt-internet"  >
                                            Mobilt internetabonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til smartwatch</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            Danmarks bedste mobilnet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Se dækningskort
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til smartwatch</span>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til smartwatch</span>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Tilbehør</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Alt tilbehør</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer"  >
                                            Alt tilbehør
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer/tilbud"  >
                                            Tilbud på tilbehør
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=premium accessories"  >
                                            Tilbehør med mobilabonnement
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/restsalg?category=smart watches;tablets;premium accessories;bluetooth headset"  >
                                            Restsalg
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tilbehørskategorier</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoeretelefoner"  >
                                            Høretelefoner
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoejttalere"  >
                                            Højttalere
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=screen protection"  >
                                            Skærmbeskyttelse
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/covers"  >
                                            Covers
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=wallets"  >
                                            Wallets
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=charges and cables"  >
                                            Opladere og kabler
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://musik.yousee.dk"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch abonnementer
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        </ul>


                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Hjælp</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mest læste artikler</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/mit-internet-virker-ikke"  >
                                            Mit internet virker ikke
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/sadan-skifter-du-betalingskort"  >
                                            Sådan skifter du betalingskort
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"  >
                                            Tag mobilen med på rejsen
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/sadan-ser-du-tv-og-film-pa-app-og-web"  >
                                            Sådan ser du tv og film med YouSee Play
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tilknyt-din-yousee-mail-til-mit-yousee-login"  >
                                            Tilknyt din YouSee Mail til Mit YouSee-login
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Hjælp til produkter</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/tv-og-streaming"  >
                                            Tv &amp; Streaming
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/internet"  >
                                            Internet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mail"  >
                                            Mail
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mobil"  >
                                            Mobil
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  >
                                            Mobilt Internet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/fastnet"  >
                                            Fastnet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/yousee-musik"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Hjælp til regning og konto</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/regning-og-betaling"  >
                                            Regning &amp; betaling
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/login-og-mit-yousee"  >
                                            Login &amp; Mit YouSee
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/sikkerhed-pa-nettet"  >
                                            Sikkerhed på nettet
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"  >
                                            Vilkår &amp; abonnement
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Andet</span>
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Tjek driftsinformation
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/hastighedstest"  >
                                            Tag hastighedstest
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/butik"  >
                                            Find YouSee butik
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                <span class="header__shortcut-name">Find mere hjælp</span>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <a class="mobile-menu__link"  href="https://selvbetjening.yousee.dk" >
                            Mit YouSee
<svg class="mobile-menu__label_arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0499 4.1665H7.08331C8.07388 6.78924 9.9936 8.9 12.3997 10.0159C10.0033 11.1273 8.08842 13.2242 7.09462 15.8332H9.06444C10.2812 13.1828 12.6405 11.2851 15.4166 10.9418L15.4166 9.08855C12.6292 8.74518 10.2618 6.8337 9.0499 4.1665Z" fill="black" fill-opacity="0.8"/>
</svg>
                        </a>

                    </li>
                </ul>
        </nav>
    </div>

    <div class="mobile-menu__bottom">
    <nav class="header__bottom-links" id="headerBottomLinks">
        <a href="https://musik.yousee.dk"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/4lE3xiTy5SaqcgxndvP7vu/dea31726d76a6f392483c4d2cea7e4ec/music-dark.svg alt="YouSee Musik" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">YouSee Musik</span>
        </a>
        <a href="https://play.yousee.dk"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/74yySyMd4CeTmzqhyCZKpz/0145a3e7beb930d0929b392cd1edca0c/play_mobile_bottom_link.svg alt="YouSee Play" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">YouSee Play</span>
        </a>
        <a href="https://sentry-authn.yousee.dk/oauth/authorize?client_id=zimbra-webmail-prod&amp;redirect_uri=https%3A%2F%2Fmityousee-odinapi.yousee.dk%2Fyousee%2Fselfcare%2Fprofile%2Fdelegated-authenticate%2Fwebmail%2Ftokens&amp;response_type=code"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/1H1YFitiwcX9cuyH0vEwdV/fb0fc313aa4213ece3653adc3b5a48ac/mail_icon_mobile_bottom_link.svg alt="Webmail" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Webmail</span>
        </a>
        <a href="https://yousee.dk/hjaelp/kontakt"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/6bKZUeJxeiSaPDGTOb1Ek9/1a9a2e2306c6ff9474264a550d0719e5/IconButton.svg alt="Kontakt os" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Kontakt os</span>
        </a>
        <a href="https://yousee.dk/hjaelp/butik"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/6bKZUeJxeiSaPDGTOb1Ek9/1a9a2e2306c6ff9474264a550d0719e5/IconButton.svg alt="Find YouSee butik" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Find YouSee butik</span>
        </a>
        <a href="https://yousee.dk/hjaelp/driftsinformation"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/4lE3xiTy5SaqcgxndvP7vu/dea31726d76a6f392483c4d2cea7e4ec/music-dark.svg alt="Driftsinformation" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Driftsinformation</span>
        </a>
    </nav>
    </div>
</div>


<script>
    (() => {
        const ACTIVE_MODIFIER = "_active";
        const ACTIVE_MENU = "_active-nav-menu";
        const HIDDEN = "_hidden";
        const VISIBLE = "_visible";

        const isHomePage = window.portal?.isHomePage;
        const isWebView = window.portal?.isWebView;
        const isShoppingCartPage = window.portal?.isShoppingCartPage;
        const isEcare = window.portal?.isEcarePage;

        const popoverElement = document.querySelector('.jsMobileMenuPopover');
        const menuButtonElement = document.querySelector('.jsMenuButtonOpen');
        const closeButtonElement = document.querySelector('.jsMenuButtonClose');
        const itemsElements = document.querySelectorAll('.jsMenuButtonNav');
        const buttonGoBackElement = document.querySelectorAll('.jsMenuButtonBack');
        const ecareMenuWrapperElement = document.getElementById('ecareMenuWrapper');
        const headerBottomLinksElement = document.getElementById('headerBottomLinks');
        const mobileMenuSearchElement = document.querySelector('.jsMobileMenuSearch');
        const mobileMenuSearchInputElement = document.querySelector('.jsMobileMenuSearchInput');
        const ecareButtonGoBackElement = document.getElementById('jsEcareNavMenuButtonBack');
        const mobileMenuElement = document.querySelector('.jsNavMenu');
        const ecareMenuElement = document.querySelector('.jsEcareNavMenu');
        const middleMenuElement = document.querySelector('.jsMiddleMenu');
        const shopLogoElement = document.querySelector('.jsShopLogo');
        const headerButtonGoBackElement = document.querySelector('.jsHeaderButtonGoBack');
        const mobileSearchCloseElement = document.querySelector('.jsMobileSearchClose');
        const searchMobileSuggestionsElement = document.querySelector('.jsSearchMobileSuggestions');
        const authButtonElement = document.querySelector('.jsAuthIcon');
        const menuBackButtonElement = document.querySelector('.jsMenuButtons');

        const setMobileSearchSuggestions = (suggestionsResponse) => {
            searchMobileSuggestionsElement.innerHTML = '';

            window.SearchService.suggestions.forEach((value) => {
                const suggestionElement = window.SearchService.createSearchSuggestionElement(value);
                searchMobileSuggestionsElement.appendChild(suggestionElement);
            });
        }

        const closeMobileSearch = () => {
            middleMenuElement.classList.remove('_active-search');
            mobileMenuSearchElement?.classList.add('_empty');

            if (mobileMenuSearchInputElement) mobileMenuSearchInputElement.value = '';
            window.SearchService.setSuggestions([]);
            if (searchMobileSuggestionsElement) searchMobileSuggestionsElement.innerHTML = '';
            popoverElement.removeEventListener('click', onMobileMenuSearchClick);
        }

        const onMobileMenuSearchClick = (event) => {
            const searchContainerElement = event.target.closest('.jsMobileMenuSearch');

            if (!searchContainerElement) {
                closeMobileSearch();
            }
        };


        function onMobileSearchInput() {
            debounce(() => {
                if(mobileMenuSearchInputElement.value.length) {
                    mobileMenuSearchElement.classList.remove('_empty');
                    const searchValue = mobileMenuSearchInputElement.value;
                    window.SearchService.requestSearchSuggestions(searchValue).then(suggestionsResponse => {
                        setMobileSearchSuggestions(suggestionsResponse);
                    });
                } else {
                    mobileMenuSearchElement.classList.add('_empty');
                    window.SearchService.setSuggestions([]);
                    searchMobileSuggestionsElement.innerHTML = '';
                }
            })();
        }

        function onMobileSearchKeyDown(event) {
            if(event.key === 'Enter') {
                const searchParams = window.SearchService.getSearchParams(mobileMenuSearchInputElement.value);
                location.href = window.SearchService.searchPageUrl + searchParams.toString();
            }
        }


        Array.from(itemsElements).forEach((e) => {
            e.addEventListener('click', function () {
                this.parentNode.classList.add(ACTIVE_MODIFIER);
                addActiveLevelAttribute(this.closest('.list').dataset.level);
                middleMenuElement.classList.add(ACTIVE_MENU);
            });
        });

        Array.from(buttonGoBackElement).forEach((e) => {
            e.addEventListener('click', function () {
                if (e.classList.contains('go-back-to-1')) {
                    addActiveLevelAttribute('0');
                    document.querySelector('.jsMenuItem._active').classList.remove(ACTIVE_MODIFIER);
                    middleMenuElement.classList.remove(ACTIVE_MENU);
                } else if (e.classList.contains('go-back-to-2')) {
                    addActiveLevelAttribute('1');
                    document.querySelector('.jsGroupItem._active').classList.remove(ACTIVE_MODIFIER);
                } else {
                    closeMenu();
                }
            });
        });

        if (ecareButtonGoBackElement) {
            ecareButtonGoBackElement.addEventListener("click", () => {
                middleMenuElement.classList.remove(ACTIVE_MENU);
                ecareMenuWrapperElement.setAttribute("style", "display: none");
                toggleMenuBar(false);
                mobileMenuElement.classList.remove(HIDDEN);
            });
        }

        window.addEventListener("ecare_initialized", () => {
            ecareMenuWrapperElement.setAttribute("style", "display: block");
            ecareMenuElement.classList.remove(HIDDEN);
            mobileMenuElement.classList.add(HIDDEN);
        })

        window.addEventListener("ecare_destroyed", () => {
            ecareMenuWrapperElement.setAttribute("style", "display: none");
            mobileMenuSearchElement?.setAttribute("style", "display: none");
            headerBottomLinksElement?.setAttribute("style", "display: none");
            ecareMenuElement.classList.add(HIDDEN);
            mobileMenuElement.classList.remove(HIDDEN);
        })

        function toggleMenuBar(ecareMobileView) {
            if (ecareMobileView) {
                mobileMenuSearchElement?.setAttribute("style", "display: none");
                headerBottomLinksElement?.setAttribute("style", "display: none");
                ecareButtonGoBackElement.setAttribute("style", "display: flex");
            } else {
                mobileMenuSearchElement?.setAttribute("style", "display: flex");
                headerBottomLinksElement?.setAttribute("style", "display: flex");
                ecareButtonGoBackElement.setAttribute("style", "display: none");
            }
        }

        function closeMenuBar() {
            mobileMenuSearchElement?.setAttribute("style", "display: none");
            headerBottomLinksElement?.setAttribute("style", "display: none");
            ecareButtonGoBackElement.setAttribute("style", "display: none");
        }

        function addActiveLevelAttribute(level) {
            middleMenuElement.dataset.activeLevel = level;
        }

        menuButtonElement?.addEventListener('click', () => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
            if (isEcare) {
                middleMenuElement.classList.add(ACTIVE_MENU);
                if (!ecareMenuElement.classList.contains(HIDDEN)) {
                    mobileMenuElement.classList.add(HIDDEN);
                }
            }
            toggleMenuBar(isEcare);
            closeButtonElement.classList.remove(HIDDEN);
            menuButtonElement.classList.add(HIDDEN);
            popoverElement.classList.add(VISIBLE);
            middleMenuElement.style.paddingRight = scrollbarWidth;
            middleMenuElement.classList.add('menu-active');
            popoverElement.style.paddingRight = scrollbarWidth;
            document.body.style.overflow = "hidden";
            if (isWebView) {
                isHomePage && shopLogoElement.classList.add(HIDDEN);
                headerButtonGoBackElement.classList.remove(HIDDEN);
            } else {
                menuBackButtonElement.classList.remove(HIDDEN);
            }
        })

        authButtonElement?.addEventListener('click', () => {
            if (document.body.clientWidth <= 767.999) {
                menuButtonElement.classList.add(HIDDEN);
                closeButtonElement.classList.remove(HIDDEN);

                if (middleMenuElement.dataset.activeLevel !== '0') {
                    addActiveLevelAttribute('0');
                }
            }
        })

        closeButtonElement.addEventListener('click', function() {
            if (isWebView && isShoppingCartPage) {
                history.back();
            } else {
                closeMenu();
            }
        })

        window.addEventListener("resize", function(){
            if(document.body.clientWidth >= 1024){
                closeMenu();
            }
        });

        isWebView && headerButtonGoBackElement.addEventListener('click', () => {
            const middleMenuEl = document.querySelector('.jsMiddleMenu');
            const activeLevel = middleMenuEl.dataset.activeLevel - 1;
            const middleMenuMap = [
                document.querySelector('.jsMenuItem._active'),
                document.querySelector('.jsGroupItem._active')
            ];
            if (middleMenuMap[activeLevel]) {
                middleMenuMap[activeLevel].classList.remove(ACTIVE_MODIFIER);
                addActiveLevelAttribute(String(activeLevel));
                return;
            }
            if (popoverElement.classList.contains(VISIBLE)) {
                closeMenu();
            } else {
                history.back();
            }
        });

        function closeMenu() {
            closeButtonElement.classList.add(HIDDEN);
            menuButtonElement.classList.remove(HIDDEN);
            popoverElement.classList.remove(VISIBLE);
            middleMenuElement.classList.remove(ACTIVE_MENU);
            addActiveLevelAttribute("0");
            document.body.style.removeProperty("overflow");
            middleMenuElement.style.removeProperty('padding-right');
            middleMenuElement.classList.remove('menu-active');
            popoverElement.style.removeProperty('padding-right');

            if (isWebView && isHomePage) {
                shopLogoElement.classList.remove(HIDDEN);
                headerButtonGoBackElement.classList.add(HIDDEN);
            }

            if (!isWebView) {
                menuBackButtonElement.classList.add(HIDDEN);
            }

            itemsElements.forEach((label) => {
                label.parentElement.classList.remove(ACTIVE_MODIFIER);
            });

            if (isEcare) {
                middleMenuElement.classList.remove(ACTIVE_MENU);
                ecareMenuWrapperElement.setAttribute("style", "display:block");
                closeMenuBar();
            }

            closeMobileSearch();
        }

        if (mobileMenuSearchInputElement) {
            mobileMenuSearchInputElement.addEventListener('focus', () => {
                middleMenuElement.classList.add('_active-search');
                popoverElement.addEventListener('click', onMobileMenuSearchClick);
            });

            mobileMenuSearchInputElement.addEventListener('input', onMobileSearchInput);
            mobileMenuSearchInputElement.addEventListener('keydown', onMobileSearchKeyDown);
            mobileSearchCloseElement.addEventListener('click', closeMobileSearch);
        }
    })();
</script>
                        </div>
                    </div>
                </div>
        </div>
            <div class="nd-header__search jsHeaderSearch">
            <div class="search__field-container page-limiter middle-page-limiter">
                <div class="search__field-container-inner jsSearchContainer">
                    <div class="search__suggestions-container">
                        <div class="search__suggestions jsSearchSuggestions"></div>
                    </div>
                    <div class="search__field-components">
                        <label class="search__field jsSearchField">
                            <input type="text"
                                class="search__input jsSearchInput"
                                placeholder="Søg"
                            />
                            <button type="button"
                                class="search__field-icon _cross jsSearchClose"
                                role="button"
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8337 14.593L11.228 9.99956L15.8229 5.39385L14.593 4.16699L9.99956 8.7727L5.39385 4.17771L4.16699 5.40764L8.7727 10.0026L4.17771 14.6083L5.40764 15.8337L10.0026 11.228L14.6083 15.8229L15.8337 14.593Z" fill="black" fill-opacity="0.8"/>
                                </svg>
                            </button>
                            <span class="search__field-icon-separator"></span>
                        </label>

                        <button type="button"
                            class="search__field-icon _search jsSearchFieldIcon"
                            tabindex="-1"
                            role="button">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.668 13.833C11.6928 14.5659 10.4805 15.0002 9.16671 15.0002C5.94505 15.0002 3.33337 12.3885 3.33337 9.16683C3.33337 5.94517 5.94505 3.3335 9.16671 3.3335C12.3884 3.3335 15 5.94517 15 9.16683C15 10.4771 14.568 11.6865 13.8387 12.6603L17.7226 16.5442H15.4167L12.668 13.833ZM13.3334 9.16683C13.3334 11.468 11.4679 13.3335 9.16671 13.3335C6.86552 13.3335 5.00004 11.468 5.00004 9.16683C5.00004 6.86564 6.86552 5.00016 9.16671 5.00016C11.4679 5.00016 13.3334 6.86564 13.3334 9.16683Z" fill="black" fill-opacity="0.6"/>
                            </svg>
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<script>
    const popupWrapperClass = '.jsPopup';
    const userButtonClass = '.jsUserButton';
    const popupWrapperSelector = document.querySelector(popupWrapperClass);
    const userButtonSelector = document.querySelector(userButtonClass);
    const logInButtonSelector = document.querySelector('.jsLogInButton');
    const logOutButtonSelector = document.querySelector('.jsLogOutButton');
    const OPENED_MODIFIER = '_opened';

    function visibilityPopup() {
        popupWrapperSelector.classList.toggle(
            OPENED_MODIFIER,
            !popupWrapperSelector.classList.contains(OPENED_MODIFIER)
        );
        resize();
    }

    function resize() {
        if (popupWrapperSelector.classList.contains(OPENED_MODIFIER)) {
            const position = userButtonSelector.getBoundingClientRect();
            if (window.innerWidth < 767) {
                popupWrapperSelector.style.right = '0px';
            } else {
                popupWrapperSelector.style.right = (window.innerWidth - position.right).toFixed() + 'px';
            }
        }
    }

    function closePopup(event) {
        const isClosest = event.target.closest(popupWrapperClass) || event.target.closest(userButtonClass)
        if (!isClosest && popupWrapperSelector.classList.contains(OPENED_MODIFIER))
            popupWrapperSelector.classList.remove(OPENED_MODIFIER)
    }


    let logOutListeners = []
    let logInListeners = []

    window.sharedNavigation = {
        addLogInListener: (listener) => logInListeners.push(listener),
        removeLogInListener: (listener) => logInListeners = logInListeners.filter(value => value !== listener),

        addLogOutListener: (listener) => logOutListeners.push(listener),
        removeLogOutListener: (listener) => logOutListeners = logOutListeners.filter(value => value !== listener),

        setUserInfo: ((userInfo) => {
            if (!!userInfo) {

                const privateInformation = document.querySelector(".jsPrivateInformation");
                if (!!userInfo.firstName) {
                    privateInformation.querySelector('.jsFirstName').textContent = userInfo.firstName;
                }
                if (!!userInfo.lastName) {
                    privateInformation.querySelector('.jsLastName').textContent = userInfo.lastName;
                }
                if (!!userInfo.firstName && !!userInfo.lastName) {
                    document.querySelectorAll('.jsAvatar').forEach((avatar) => avatar.textContent =
                        (userInfo.firstName[0] + userInfo.lastName[0]).toUpperCase());
                }
                userButtonSelector.hidden = false;
                logInButtonSelector.hidden = true;
            } else {
                popupWrapperSelector.classList.remove('_opened');
                userButtonSelector.hidden = true;
                logInButtonSelector.hidden = false;
            }
        }),
    }

    function logOut() {
        logOutListeners.forEach(listener => listener())
    }

    function logIn() {
        logInListeners.forEach(listener => listener())
    }

    document.addEventListener('click', closePopup);
    window.addEventListener('resize', resize);

    userButtonSelector.addEventListener('click', visibilityPopup);
    logInButtonSelector.addEventListener('click', logIn);
    logOutButtonSelector.addEventListener('click', logOut);
</script>
<script>
    (function() {
        const menuItems = document.querySelectorAll('.jsNavMenuItem');
        const overlay = document.querySelector('.jsNavMenuOverlay');

        const updateOverlayVisibility = () => {
            const isAnyMenuItemActive = Array.from(menuItems).some(item => {
                const menuContainer = item.querySelector('.jsNavMenuItemContainer');
                return (item.classList.contains('_hover') || item.classList.contains('_leaving')) &&
                    (menuContainer && menuContainer.style.visibility === 'visible');
            });

            if (isAnyMenuItemActive) {
                overlay.classList.add('_open');
            } else {
                overlay.classList.remove('_open');
            }
        };

        const removeLeaveForItems = debounce(function() {
            menuItems.forEach(function(item) {
                if (item.classList.contains("_leaving")) {
                    updateOverlayVisibility();
                    item.classList.remove("_leaving");
                }
            });
        }, 500);

        menuItems.forEach(function(menuItem) {
            menuItem.addEventListener('mouseover', openHoveredOrFocusedMenuItemAndCloseOther);
            menuItem.querySelector('.jsNavMenuLabel').addEventListener('focus', openHoveredOrFocusedMenuItemAndCloseOther);

            menuItem.addEventListener('mouseleave', function(){
                menuItem.classList.add("_leaving");
                menuItem.classList.remove("_hover");
                removeLeaveForItems();
            });

            ['a.jsNavMenuLabel', 'button.jsNavMenuLabel'].forEach(function(selector) {
                menuItem
                    .querySelectorAll(selector)
                    .forEach(addMainMenuNavigationListener);
            });

            function openHoveredOrFocusedMenuItemAndCloseOther() {
                removeHoverForAllItems();
                menuItem.classList.add('_hover');
                const menuContainer = menuItem.querySelector('.jsNavMenuItemContainer');
                menuContainer ? overlay.classList.add('_open') : overlay.classList.remove('_open');
            }

            function addMainMenuNavigationListener(element) {
                element.addEventListener('keydown', triggerMainMenuNavigation);
            }
        });

        function triggerMainMenuNavigation(event) {
            if (event.key === 'Tab') {
                const currentElement = event.target;
                const currentTopLevelMenuItemWrapper = currentElement.closest('.jsNavMenuItem');
                const previousTopLevelMenuItemWrapper = currentTopLevelMenuItemWrapper.previousElementSibling;
                const nextTopLevelMenuItemWrapper = currentTopLevelMenuItemWrapper.nextElementSibling;
                const menuItemHasDropdown = currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('nav-menu__item-container');
                const firstLinkInDropdown = menuItemHasDropdown && currentElement.nextElementSibling.querySelector('.jsNavMenuLink');

                // reverse navigation
                if (event.shiftKey) {
                    if (previousTopLevelMenuItemWrapper) {
                        // switch focus to previous top level menu item
                        previousTopLevelMenuItemWrapper.querySelector('.jsNavMenuLabel').focus();
                    } else {
                        // switch focus to logo
                        removeHoverForAllItems();
                        document.querySelector('.jsNavLogoLink').focus();
                    }
                } else {
                    if (menuItemHasDropdown && firstLinkInDropdown) {
                        // we need to go deeper if there is dropdown with links
                        firstLinkInDropdown.focus();
                    } else if (nextTopLevelMenuItemWrapper) {
                        // switch focus to next top menu element
                        nextTopLevelMenuItemWrapper.querySelector('.jsNavMenuLabel').focus();
                    } else {
                        // switch focus to search
                        removeHoverForAllItems();
                        document.querySelector('.jsSearchOpen').focus();
                    }
                }

                event.preventDefault();
                return false;
            }
        }

        function removeHoverForAllItems() {
            menuItems.forEach(function(item) {
                item.classList.remove("_hover");
                item.classList.remove("_leaving");
            });
        }
    })();
</script>
<script>
        class SearchService {
            suggestions;
            siteKey;
            autocompleteUrl;
            searchPageUrl;
            inputType;

            constructor () {
                this.suggestions = [];
                this.siteKey = "MjA1MzoxMDExMzpTZWFyY2hLZXk=";
                this.autocompleteUrl = "https://api.cludo.com/api/v3/2053/10113/autocomplete";
                this.searchPageUrl = "https://yousee.dk/soeg?#?";
                this.inputType = "standard";
            }

            setSuggestions = (suggestions) => {
                this.suggestions = suggestions;
            }

            createSearchSuggestionElement = (searchValue) => {
                const searchParams = this.getSearchParams(searchValue);
                const suggestionElement = document.createElement('a');
                suggestionElement.setAttribute('href', this.searchPageUrl + searchParams.toString());
                suggestionElement.classList.add('search__suggestion');
                suggestionElement.innerText = searchValue;
                return suggestionElement;
            }

            getSearchParams(searchValue) {
                const params = {
                    cludoquery: searchValue,
                    cludoinputtype: this.inputType,
                    cludopage: 1,
                    cludorefurl: location.href,
                    cludorefpt: document.title
                }

                return Object.entries(params).map(param => param.map(encodeURIComponent).join("=")).join("&");
            }

            requestSearchSuggestions = async (searchValue) => {
                this.suggestions = [];

                const url = new URL(this.autocompleteUrl);
                url.searchParams.append("query", searchValue);
                url.searchParams.append("responsetype", this.inputType);
                url.searchParams.append("results", 10);

                const autocompleteResponse = await fetch(url, {
                    headers: {
                        "Content-type": "application/json",
                        'Authorization':  'SiteKey '+ this.siteKey
                    }
                });
                const suggestionsResponse = await autocompleteResponse.json();
                this.setSuggestions(suggestionsResponse);

                return Promise.resolve(suggestionsResponse);
            }
        }

        window.SearchService = new SearchService();
</script>
<script>
    (function() {
        // Elements
        const searchFieldElement = document.querySelector(".jsSearchField");
        const searchFieldIconElement = document.querySelector(".jsSearchFieldIcon");
        const headerSearchElement = document.querySelector(".jsHeaderSearch");
        const searchInputElement = document.querySelector(".jsSearchInput");
        const searchSuggestionsElement = document.querySelector(".jsSearchSuggestions");
        const searchCloseElement = document.querySelector(".jsSearchClose");
        const searchOpenElement = document.querySelector(".jsSearchOpen");

        // Event Listeners
        searchInputElement.addEventListener('keydown', onSearchKeyDown);
        searchCloseElement.addEventListener('click', onSearchClose);
        searchCloseElement.addEventListener('keydown', onSearchCrossKeydown);
        searchSuggestionsElement.addEventListener('keydown', onSearchSuggestionsKeydown);
        searchOpenElement.addEventListener('click', onSearchOpen);

        // State Variables
        let focusedSuggestionIndex = -1;

        window.addEventListener("scroll", function() {
            if (searchFieldElement.classList.contains('_opened')) {
                onSearchClose();
            }
        });

        window.addEventListener("resize", function() {
            if (searchFieldElement.classList.contains('_opened')) {
                onSearchClose();
            }
        });

        function onWindowClick(event) {
            const searchContainerElement = event.target.closest('.jsSearchContainer');
            if (!searchContainerElement) {
                onSearchClose();
            }
        }

        function onSearchOpen() {
            headerSearchElement.style.display = 'block';
            setTimeout(() => {
                searchFieldElement.classList.add('_opened');
                searchFieldIconElement.style.display = 'flex';
                setSearchFocus();
                window.addEventListener("click", onWindowClick);
            });
        }

        function onSearchClose() {
            searchFieldElement.classList.remove('_opened');
            searchSuggestionsElement.innerHTML = '';
            window.SearchService.setSuggestions([]);
            focusedSuggestionIndex = -1;

            setTimeout(() => {
                searchFieldIconElement.style.display = 'none';
                headerSearchElement.style.display = 'none';
                searchInputElement.value = '';
                window.removeEventListener("click", onWindowClick);
            }, 400);
        }

        function setSearchFocus() {
            setTimeout(() => {
                searchInputElement.focus();
            }, 400);
        }

        function setSearchSuggestions(suggestionsResponse) {
            if (searchFieldElement.classList.contains('_opened')) {
                searchSuggestionsElement.innerHTML = '';

                window.SearchService.suggestions.forEach((value) => {
                    const suggestionElement = window.SearchService.createSearchSuggestionElement(value);
                    searchSuggestionsElement.appendChild(suggestionElement);
                });
            }
        }

        const fetchSuggestions = debounce(() => {
            if (searchInputElement.value) {
                window.SearchService.requestSearchSuggestions(searchInputElement.value).then(suggestionsResponse => {
                    setSearchSuggestions(suggestionsResponse);
                });
            } else {
                window.SearchService.setSuggestions([]);
                setSearchSuggestions([]);
            }
        }, 500);

        function onSearchKeyDown(event) {
            requestAnimationFrame(function() {
                switch (event.key) {
                    case 'ArrowDown':
                        if (window.SearchService.suggestions.length) {
                            focusedSuggestionIndex = 0;
                            searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                        }
                        break;
                    case 'ArrowUp':
                        if (window.SearchService.suggestions.length) {
                            focusedSuggestionIndex = window.SearchService.suggestions.length - 1;
                            searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                        }
                        break;
                    case 'Enter':
                        const searchParams = window.SearchService.getSearchParams(searchInputElement.value);
                        location.href = window.SearchService.searchPageUrl + searchParams.toString();
                        break;
                    default:
                        fetchSuggestions();
                        break;
                }
            });
        }

        function onSearchCrossKeydown(event) {
            switch (event.key) {
                case 'ArrowDown':
                    if (window.SearchService.suggestions.length) {
                        focusedSuggestionIndex = 0;
                        searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    }
                    break;
                case 'ArrowUp':
                    if (window.SearchService.suggestions.length) {
                        focusedSuggestionIndex = window.SearchService.suggestions.length - 1;
                        searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    }
                    break;
                case 'ArrowLeft':
                    searchInputElement.focus();
                    break;
                case 'Tab':
                    onSearchClose();
                    break;
            }
        }

        function onSearchSuggestionsKeydown(event) {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    focusedSuggestionIndex = focusedSuggestionIndex === window.SearchService.suggestions.length - 1 ? 0 : focusedSuggestionIndex + 1;
                    searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    focusedSuggestionIndex = focusedSuggestionIndex === 0 ? window.SearchService.suggestions.length - 1 : focusedSuggestionIndex - 1;
                    searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    break;
                case 'Tab':
                    event.preventDefault();
                    if (focusedSuggestionIndex === window.SearchService.suggestions.length - 1) {
                        focusedSuggestionIndex = -1;
                        searchInputElement.focus();
                    } else {
                        focusedSuggestionIndex = focusedSuggestionIndex + 1;
                        searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    }
                    break;
            }
        }
    })();
</script>
<script>
    // header styles
    (function() {
        let firstRender = true;
        const headerResizeObserver = new ResizeObserver(function(entries) {
            document.documentElement.style.setProperty('--nd-total-header-height', entries[0]?.contentRect.height + 'px');

            if (firstRender) {
                firstRender = false;
                document.querySelector('.default-body')?.classList.add('_no-animation');

                setTimeout(() => {
                    document.querySelector('.default-body')?.classList.remove('_no-animation');
                })
            }
        });

        headerResizeObserver.observe(document.querySelector('.nd-header'));
    })();

    (function() {
        const bodyMutationObserver = new MutationObserver(function(mutations) {
            const header = document.querySelector('.nd-header');
            mutations.forEach(function(mutation) {
                if(mutation.attributeName === 'style'){
                    if (mutation.target.style.overflow === "hidden"){
                        header.style.paddingRight = mutation.target.style.paddingRight;
                    } else {
                        header.style.removeProperty("overflow");
                        header.style.removeProperty("padding-right");
                    }
                }
            });
        });

        bodyMutationObserver.observe(document.body, {
            attributes: true,
            attributeFilter: [ 'style' ]
        });
    })();

    // set header top line size
    (function() {
        const topHeaderResizeObserver = new ResizeObserver(function(entries) {
            document.documentElement.style.setProperty('--nd-header-top-height', entries[0]?.contentRect.height + 'px');
        });
        topHeaderResizeObserver.observe(document.querySelector('.nd-header__top'));
    })();

    // hide or show top line
    (function() {
        window.addEventListener("scroll", function() {
            const headerTop = document.querySelector('.nd-header');
            const heightHeaderTop = parseInt(document.documentElement.style.getPropertyValue('--nd-header-top-height'));

            if (headerTop) {
                if (
                    document.body.scrollTop > heightHeaderTop
                    || document.documentElement.scrollTop > heightHeaderTop
                ) {
                    document.body.classList.add("_hiddenHeaderTop");
                } else if (document.body.scrollTop === 0 && document.documentElement.scrollTop === 0) {
                    document.body.classList.remove("_hiddenHeaderTop");
                }
            }
        });
    })();
</script>


    <script>
        (function() {
            window.portal = window.portal ?? {};
            ({
                chat: window.portal.chat,
                adobeCookieName: window.portal.adobeCookieName,
                mobileAppChatEnabled: window.portal.mobileAppChatEnabled,
            } = JSON.parse('{\"chat\":{\"enable\":true,\"endpointURL\":\"https:\/\/endpoint-yousee.cognigy.cloud\/e360170a4dd67fee63a97b2ea858f5bc127edfae0c003585122201f7568de847\"},\"mobileAppChatEnabled\":true,\"adobeCookieName\":\"AMCV\u00CF_0BD6E1CE5440F9CA0A4C98A5%40AdobeOrg\"}'));

            class ChatUtils {
                #configuration = window.portal.chat;
                #isInitialized = false;

                #sessionInfo = {};
                #sessionData = {};
                #prevMessageParams;

                init({ sessionInfo = {}, sessionData = {} } = {}) {
                    if (!this.#configuration?.endpointURL || this.#isInitialized) return;

                    this.#sessionInfo = sessionInfo;
                    this.#sessionData = sessionData;

                    loadScript('//assets.ctfassets.net/qn2mzafc6iit/3CclInqfHw7iDxnVrv8nUH/f737ec94508b999258307d06d4ecabe4/webchat.txt', this.#initInstance.bind(this));

                    if ('//assets.ctfassets.net/qn2mzafc6iit/3oRmRSfoz508o75GAgwX1h/c64a80eadf6ac9d6a5c15ca826f4f313/chat-styles-v13-temp-fix.css') loadStyle('//assets.ctfassets.net/qn2mzafc6iit/3oRmRSfoz508o75GAgwX1h/c64a80eadf6ac9d6a5c15ca826f4f313/chat-styles-v13-temp-fix.css');
                    if ('') loadStyle('');

                    this.#isInitialized = true;
                }

                updateParams({ sessionInfo = {}, sessionData = {} } = {}) {
                    if (!this.instance) return;

                    deepAssign(this.#sessionInfo ?? {}, sessionInfo);
                    deepAssign(this.#sessionData ?? {}, sessionData);

                    const messageParams = {
                        sourceData: {
                            ...this.#sessionData?.customerData,
                            adobeId: getAdobeId(),
                            currentUrl: window.location.href,
                            platform: getPlatform(),
                            mobileAppVersion: window.portal.chatParams?.mobileAppVersion
                        }
                    };

                    // HOTFIX for Connigy to not send messages after opening
                    // if (isEqual(messageParams, this.#prevMessageParams)) {
                    if (!!this.#prevMessageParams) {
                        return;
                    }
                    this.#prevMessageParams = messageParams;

                    this.instance.sendMessage('', messageParams);
                }

                open(triggerType, payload) {
                    if (!this.instance) return;

                    const trigger = {
                        datetime: new Date().toISOString(),
                        type: triggerType || this.#sessionData?.defaultTrigger?.type,
                        url: (
                            payload?.triggerUrl ||
                            this.#sessionData?.defaultTrigger?.payload?.triggerUrl ||
                            window.location.href
                        ),
                        payload
                    };

                    this.#openWithTrigger(trigger);
                }

                #openWithTrigger(trigger, forceSendMessage = false) {
                    if (!(window.portal.isWebView && window.portal.mobileAppChatEnabled) || forceSendMessage) {
                        if (!this.instance) return;

                        const messageParams = { sourceData: { trigger } };

                        this.instance.sendMessage('', messageParams);
                        this.instance.open();
                        this.instance.startConversation();
                    } else {
                        window.document.dispatchEvent(
                            new CustomEvent('OpenChat', {
                                detail: trigger
                            })
                        );
                    }
                }

                #initInstance() {
                    if (!this.#configuration?.endpointURL) return;

                    initWebchat(this.#configuration?.endpointURL, {
                        userId: this.#sessionInfo?.userId
                    }).then(instance => {
                        this.instance = instance;
                        this.#registerAnalyticsService();
                        window.portal.openChat = this.open;
                    });

                    this.#defineChatParams();
                }

                #defineChatParams() {
                    const self = this;

                    Object.defineProperty(window.portal, 'chatParams', {
                        get() {
                            return window.portal._chatParams;
                        },
                        set(value) {
                            window.portal._chatParams = value;

                            if (value.open) {
                                self.#openWithTrigger(value.triggerData, true);
                            }
                        }
                    });
                }

                #registerAnalyticsService() {
                    this.instance.registerAnalyticsService(event => {
                        if (event.type === 'webchat/open') {
                            this.updateParams();
                        } else if (event.type === 'webchat/incoming-message') {
                            if (event.payload?.data?.token_refresh) {
                                this.#sendAccessToken();
                            } else if (event.payload?.data?.nd_action === 'close_widget') {
                                this.instance.close();
                            }
                        }
                    });
                }

                #sendAccessToken() {
                    if (!this.instance) return;

                    const messageParams = {
                        accessToken: this.#sessionData?.customerData?.accessToken,
                        trigger: {
                            type: 'refresh_token',
                            triggerDatetime: Date.now()
                        }
                    };

                    this.instance.sendMessage('', messageParams);
                }
            }

            class Cookies {
                static get(name) {
                    const cookies = document.cookie.split('; ');

                    for (const cookie of cookies) {
                        const [key, value] = cookie.split('=');
                        if (key === name) return value;
                    }

                    return '';
                }
            }

            function loadScript(src, onloadCallback) {
                const script = document.createElement('script');
                script.src = src;
                script.onload = onloadCallback;
                document.head.appendChild(script);
            }

            function loadStyle(href) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                document.head.appendChild(link);
            }

            function getAdobeId() {
                const ADOBE_COOKIE_NANE = window.portal.adobeCookieName;
                const adobeCookie = Cookies.get(ADOBE_COOKIE_NANE);

                if (adobeCookie) {
                    const decodedAdobeCookie = decodeURI(adobeCookie);
                    const adobeId = decodedAdobeCookie.split('|')[4];

                    return adobeId;
                }
            }

            function getPlatform() {
                return window.portal.isWebView ? 'mobile' : 'web';
            }

            function deepAssign(target, source) {
                for (const key in source) {
                    const sourceValue = source[key];
                    const targetValue = target[key];

                    const areBothObjects =
                        typeof targetValue === 'object' && targetValue !== null &&
                        typeof sourceValue === 'object' && sourceValue !== null;

                    target[key] = areBothObjects
                        ? deepAssign(targetValue, sourceValue)
                        : sourceValue;
                }
            }

            window.sharedNavigation ??= {};
            window.sharedNavigation.chat = new ChatUtils();
        })();
    </script>
`;
